<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <store-settings-general />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-package" :label="!isSmallerScreen ? 'Fulfillment' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <store-fulfillment/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-dollar-sign" :label="!isSmallerScreen ? 'Shipping Rate' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <rate-setting />
      </div>
    </vs-tab>
   <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Payment Accepted' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <payment />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Card Details' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <CreditCard />
      </div>
    </vs-tab>
    <!--<vs-tab icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? 'Connections' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <profile-settings-connections />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notifications' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <profile-settings-notifications />
      </div>
    </vs-tab>-->
  </vs-tabs>
</template>

<script>
import StoreSettingsGeneral from './StoreSettingsGeneral.vue'
import StoreFulfillment from './StoreFulfillment.vue'
import Payment from './Payment.vue'
import CreditCard from './StoreSettingCreditCardList.vue'
import RateSetting from './ShippingRate.vue'

export default {
  components: {
    StoreSettingsGeneral,
    StoreFulfillment,
    Payment,
    CreditCard,
    RateSetting,
  },
  data () {
    return {

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
